// extracted by mini-css-extract-plugin
export default {"subtitle":"styles_subtitle__gMemj","bold":"styles_bold__FD0Oa"};